import { FileCopyOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import CustomCard from "components/CustomCard";
import CustomLink from "components/CustomLink";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";

const Documents = ({ data, setDialogTitle, getData }) => {
    const { bt } = useBizTypeTranslation();

    return (
        <CustomCard>
            <Stack direction="row" justifyContent="space-between">
                <Stack direction="row" alignItems="center" spacing={1} >
                    <Typography fontSize={18} fontWeight="bold">{bt("DOCUMENTS")}</Typography>
                    <Typography fontSize={12} >{`(${bt("YEARLY")})`}</Typography>
                </Stack>
                <CustomLink title="IMPORT_DATA" onClick={() => getData()} />
            </Stack>

            <Stack
                useFlexGap
                sx={{ flexWrap: 'wrap' }}
                direction={{ xs: "column", md: "row" }}
                justifyContent={{ xs: "center", md: "start" }}
                spacing={{ xs: 1, md: 2 }}
            >
                {data?.filter(i => i?.show)?.map((st, idx) => {
                    return (
                        <CustomCard
                            key={idx}
                            alignItems="center"
                            direction="row"
                            width={{ xs: "100%", md: 260 }}
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                setDialogTitle(bt(st?.name));
                                st?.onClick(st?.list);
                            }}
                        >
                            <Stack
                                width={{ xs: 50, md: 70 }}
                                height={{ xs: 50, md: 70 }}
                                bgcolor={st?.iconBgColor}
                                borderRadius={10}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <FileCopyOutlined sx={{ color: st?.iconColor }} />
                            </Stack>

                            <Stack padding={{ xs: 0, md: 1 }}>
                                <Stack height="100%" alignItems="center" direction="row" spacing={0.5}>
                                    <Typography fontSize={{ xs: 12, md: 14 }}>
                                        {bt(st?.name)}
                                    </Typography>

                                    <Typography fontSize={{ xs: 12, md: 14 }}>
                                        {`${st?.subValue ? `(${st?.subValue})` : ""}`}
                                    </Typography>
                                </Stack>

                                <Typography fontSize={{ xs: 20, md: 24 }} fontWeight="bold">
                                    {st?.value}
                                </Typography>
                            </Stack>
                        </CustomCard>
                    )
                })}


            </Stack>
        </CustomCard>
    );
};

export default Documents;